import Transformer from '@/transformers/transformer'

export default class supplyConfigTransformer extends Transformer {
  static fetch({
    supply_name: supplyName, oc, subtotal, id, current_stock: currentStock,
    cu, code, has_config_iwarehouse_supply: hasConfig, unit_measurement: unitMeasurement,
    assigned_stock: assignedStock, physical_stock: physicalStock
  }) {
    return {
      supplyName,
      oc,
      subtotal,
      id,
      currentStock,
      cu,
      code,
      hasConfig,
      unitMeasurement,
      assignedStock,
      physicalStock
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/stockReport.js